import store from "../store";
import util from "../util";
import * as actions from '../actions';
import tinycolor from 'tinycolor2';

export function wrapToCurve($element, fontSize=false) {
  if ($element.find('#svgWrap')) {
    if (!fontSize) {
      fontSize = parseFloat($element.find('#svgWrap text').css("fontSize"));
    }

    $element.find('#svgWrap').remove();
  }

  if (!fontSize) {
    fontSize = 10;
  }

  const $qlContainer = $element.find('.ql-container');
  const $qlEditor = $element.find('.ql-editor');
  const qlEditorChildren = $qlEditor.children();
  const text = Array.from(qlEditorChildren.map(function() {
    return $(this).text();
  })).join(' ');
  const elementStyles = getStyles($element[0]);
  const color = elementStyles["color"];

  if (util.isPixelDesign()) {
    const pageFontStyles = getStyles($element.closest('.page')[0]);
    fontSize = parseFloat(pageFontStyles['font-size']);
    const firstChildFontStyles = getStyles(qlEditorChildren.get(0));
    fontSize = fontSize * parseInt(firstChildFontStyles['font-size'])/100;
  }

  let origin = 0;
  let widthStyle = elementStyles["width"];
  if (widthStyle.includes("%")) {
    origin = util.percentToPixel(parseFloat(widthStyle), util.getActiveDimensions().width) / 2;
  } else {
    origin = parseFloat(elementStyles["width"]) / 2;
  }
  let radius = origin / 2;
  let negativeCurve = false;
  if ($element.attr('data-curve-value')) {
    const curveVal = parseFloat($element.attr('data-curve-value')) / 20;
    if (curveVal !== 0) {
      let inverseCurveVal = 1 / parseFloat($element.attr('data-curve-value'));
      radius = Math.abs(radius * inverseCurveVal);
      negativeCurve = inverseCurveVal < 0;
    } else {
      $element.attr('data-text-wrapped', "false");
      store.dispatch(actions.updateElementAttribute('textWrapped', false));
    }
  } else {
    $element.attr('data-curve-value', '1');
    store.dispatch(actions.updateElementAttribute('curveValue', '1'));
  }
  const diameter = radius * 2;
  const containerStyles = getStyles($qlContainer[0]);
  const firstChildStyles = getStyles($element.find('.ql-editor *:first-child')[0]);
  //const qlChildren = $element.find('.ql-editor>*:first-child>*');
  const $qlGrandchild = $element.find('.ql-editor>*:first-child>*:first-child');
  const firstGrandchildStyles = $qlGrandchild.length > 0 ? getStyles($qlGrandchild[0]) : null;

  const fontFamily = firstChildStyles["font-family"];
  const letterSpacing = firstGrandchildStyles ? firstGrandchildStyles["letter-spacing"] : 0;
  const isBold = $qlEditor.find('strong').length > 0;
  const isItalic = $qlEditor.find('em').length > 0;
  const isUnderline = $qlEditor.find('u').length > 0;
  const isUppercase = $qlEditor.find('.case-up').length > 0;
  const opacity = containerStyles["opacity"] || 1;

  const className = util.UUID.get();
  const pathID = util.UUID.get();

  function getSvgWrapStyle(extraStyle) {
    return `position: absolute; ${extraStyle} width: 100%; height: 100%; pointer-events: none; z-index: -1;`;
  }

  let newEl = document.createElement('div');
  newEl.id = "svgWrap";
  if (!negativeCurve) newEl.style = getSvgWrapStyle(`top: ${-1 * (origin - radius - fontSize/2) + 3}px;`);
  let svgObj = `<svg style="overflow: visible; width: 100%; height: 100%;">
    <defs>
      ${negativeCurve ? 
      `<path id="${pathID}"
          d="M ${origin}, -${origin}
            m 0, -${radius}
            a ${radius},${radius} 0 1,0 0,${diameter}
            a ${radius},${radius} 0 1,0 0,-${diameter}" />` :
      `<path id="${pathID}"
            d="M ${origin}, ${origin}
              m 0, ${radius}
              a ${radius},${radius} 0 1,1 0,-${diameter}
              a ${radius},${radius} 0 1,1 0,${diameter}" />`
      }
    </defs>

    <style>
      .${className} {
        font-family: ${fontFamily};
        font-size: ${fontSize}px;
        letter-spacing: ${letterSpacing};
        fill: ${color};
        ${isBold ? "font-weight: bold;" : ""}
        ${isItalic ? "font-style: italic;" : ""}
        ${isUnderline ? "text-decoration: underline;" : ""}
        ${isUppercase ? "text-transform: uppercase;": ""}
        opacity: ${opacity};
        pointer-events: all;
      }
    </style>

    <text class="${className}">
      <textPath xlink:href="#${pathID}" text-anchor="middle" dominant-baseline="middle" startOffset="50%">
        ${text}
      </textPath>
    </text>
  </svg>`;
  newEl.innerHTML = svgObj;
  $element.append(newEl);

  if (negativeCurve) {
    const txtHeight = $element.find('#svgWrap>svg>text')[0].getBBox().height;
    newEl.style = getSvgWrapStyle(`bottom: ${radius - origin - txtHeight + fontSize/2}px;`);
  }

  $element.attr('data-text-wrapped', "true");
  store.dispatch(actions.updateElementAttribute('textWrapped', true));
}

function getStyles(element) {
  var style = element.style;
  var ret = {};
  for (var i = 0; i < style.length; ++i) {
      var item = style.item(i);
      ret[item] = style[item];
  }
  return ret;
}

function getTextWidth(text, font) {
  // re-use canvas object for better performance
  const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
  const context = canvas.getContext("2d");
  context.font = font;
  const metrics = context.measureText(text);
  return metrics.width;
}

function getCssStyle(element, prop) {
    return window.getComputedStyle(element, null).getPropertyValue(prop);
}

function getCanvasFont(el = document.body) {
  const fontWeight = getCssStyle(el, 'font-weight') || 'normal';
  const fontSize = getCssStyle(el, 'font-size') || '16px';
  const fontFamily = getCssStyle(el, 'font-family') || 'Times New Roman';
  
  return `${fontWeight} ${fontSize} ${fontFamily}`;
}

function applyShadow($element, offset = 1, direction = 0, blur = 0, opacity = 1, color = "#000") {
  let offsetX = 0;
  let offsetY = 0;

  const directionRadians = util.toRadians(direction);
  offsetX = Math.cos(directionRadians);
  offsetY = Math.sin(directionRadians);
  offsetX = offsetX * (offset / 20);
  offsetY = offsetY * (offset / 20) * -1;

  const tc = tinycolor(color);
  tc.setAlpha(opacity);
  const colorWithAlpha = tc.toRgbString();

  $element.css('text-shadow', `${offsetX}em ${offsetY}em ${blur}px ${colorWithAlpha}`);
}

function removeShadow($element) {
  $element.css('text-shadow', 'none');
}

export default {
  getStyles,
  getTextWidth,
  getCssStyle,
  getCanvasFont,
  applyShadow,
  removeShadow
}